import parse from 'html-react-parser';
import DOMPurify from 'dompurify';

import components from './components';

const Content = ({ html, context, ...props }) => {

  const replace = (node) => {

    if (node.type === 'text') {

      const text = node.data;
      const parts = text.split(/(\[.+\])/g);

      return <>
        {
          parts.map((part, key) => {

            const match = part.match(/\[(\w+)([^\]]*)\]/);

            if (match === null) {
              return part;

            } else {
              const tag = match[1];
              const att = match[2];

              const Component = components[tag];
              if (!Component) {
                return null;
              }

              const attrs = [...att.matchAll(/([\w:-]+)="([^"]*)"/g)];

              const props = Object.fromEntries(attrs.map(attr => {

                const key = attr[1];
                const val = attr[2];

                return [key, val];
              }));

              return (
                <Component
                  key={key}
                  context={context}
                  {...props}
                />
              );
            }
          })
        }
      </>;
    };
  };

  return (
    <div {...props}>
      {
        parse(
          DOMPurify.sanitize(html),
          { replace },
        )
      }
    </div>
  );
};

export default Content;